module.exports = __webpack_public_path__ + "img/gb32_1.prt.eb994649.jpg";